import cx from 'classnames';
import styles from './Loading.module.scss';

import { FC } from 'react';
import { Typography } from '../Typography';
import { useTranslation } from 'react-i18next';

interface LoadingProps {
  className?: string;
}

export const Loading: FC<LoadingProps> = ({ className }) => {
  const { t } = useTranslation('mainPage');

  return (
    <Typography component="ticket-h2" className={cx(styles.loadingGradient, className)}>
      {t('loading')}
    </Typography>
  );
};
